import { z } from 'zod';

export const bankDetailsGetResponseSchema = z.object({
  data: z.object({ account_number: z.string().optional(), sort_code: z.string().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
